<!-- 人机对战-->
<template>
  <div class="man-machine">
    <div class="header">
      <div class="user">
        <div class="img">
          <img :src="studentInfo.avatar" alt />
          <div class="witchOne" v-if="!whoisWIN&&whoChess%2 === 0">下棋中</div>
        </div>
        <div class="user-item">
          <div class="username">
            <div class="longText">{{studentInfo.nickname}}</div>
            <span>{{stu_kvalue/1000}}K</span>
          </div>
          <div class="status">提 {{winStep}} 子</div>
        </div>
      </div>
      <div class="vs">
        <div>VS</div>
        <div class="witchWin" v-if="whoisWIN">{{whoisWIN}}</div>
      </div>
      <div class="user">
        <div class="img">
          <img :src="mechineInfo.headerImg" alt />
          <div class="witchOne" v-if="!whoisWIN&&whoChess%2 !==0">下棋中</div>
        </div>
        <div class="user-item">
          <div class="username">
            <div class="longText">{{mechineInfo.name}}</div>
            <span>{{mechineInfo.K_value}}K</span>
          </div>
          <div class="status">提 {{machineStep}} 子</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="mes-right" @click="showRelusModel">
        <img src="../assets/imgs/question/rules.png" alt />
      </div>
      <!--人机-->
      <canvas width="540" height="540" ref="machine"></canvas>
    </div>
    <div
      class="confirm-button"
      :class="!isChess&&'checkedGray'"
      @click="manMechineClick"
      v-if="!isWin&&dotimes <= 2"
    >确认</div>
    <div class="confirm-button" @click="startOnce" v-if="nextPlay">开始下一局</div>
    <div class="confirm-button reStart" v-if="isWin&&dotimes>=2" @click="goBack">返回</div>
    <Rules :text="rules_text" v-if="ruleModeShow" @close="closeRelus"></Rules>

    <!-- 平局  -->
    <van-popup v-model="equalResultShow" class="success-full-screen" @close="beforeClose">
      <!-- <img src="../assets/imgs/question/right.png">
      <div class="success-text">打谱成功！</div>-->
      <div @click="closeSuccessBack" class="equal-imgs"></div>
    </van-popup>
    <!-- 获胜局 -->
    <van-popup v-model="successResultShow" class="success-full-screen" @close="beforeClose">
      <!-- <img src="../assets/imgs/question/right.png">
      <div class="success-text">打谱成功！</div>-->
      <div @click="closeSuccessBack" class="win-imgs"></div>
    </van-popup>
    <!-- 失败局 -->
    <van-dialog
      class="wrong-modal hide"
      style="overflow: initial;"
      v-model="failResultShow"
      show-cancel-button
      confirm-button-text="重新对弈"
      cancel-button-text="退出本次对弈"
      :before-close="loseDY"
    >
      <div class="wrong-wrap">
        <div class="wrong-imgs"></div>
        <div class="wrong-title">我输了</div>
        <div class="wrong-desc">继续努力!</div>
      </div>
      <!-- <div @click="closeFailConfirm" class="close-modal"></div> -->
    </van-dialog>
    <Score v-if="isScoreActive" :score="score" :onClose="handleScoreClose"></Score>
  </div>
</template>

<script>
import { mechineNameArr } from '../utils/const'
import Island from '../lib/island'
import * as Api from '../api/index'
import Rules from '@/components/rules.vue'
import Score from '@/components/score.vue'

export default {
  name: 'manMachine',
  data() {
    return {
      studentInfo: {},
      mechineInfo: {
        headerImg: '',
        name: '',
        k_value: ''
      }, // 机器人信息
      equalResultShow: false,
      successResultShow: false,
      failResultShow: false,
      winStep: 0, // 用户提子数量
      machineStep: 0, // 机器人提子数量
      blackSpot: true,
      userStatus: true,
      level: '', // 难度等级
      isWin: false, // 是否赢下
      nextPlay: false, // 显示下一局
      student_answer: '',
      dotimes: 0, // 当前做了几次
      whoChess: 0, // 默认为用户为 黑棋  --偶数为黑 奇数为白
      playResult: [], // 玩家对战的结果
      student_steps: 0, // 学生吃子数量
      robot_steps: 0, // 机器人吃子数量
      stu_kvalue: 0, // 学生K值
      rules_text: '每次下2局，2胜得25分。',
      ruleModeShow: false,
      whoisWIN: '', // 谁赢
      isChess: false, // 是否落子 初始化中默认需要落子
      winTimes: 0, // 记录赢的次数
      equalTimes: 0, // 记录平局的次数
      loseTimes: 0, // 记录输的次数
      isScoreActive: false,
      score: 0
    }
  },
  components: { Rules, Score },
  created() {
    Api.studentList().then(res => {
      console.log(res)
      if (res.status === 0) {
        this.studentInfo = res.content.base_info
        this.stu_kvalue = res.content.extend_info.k_value
      }
    })
    this.initLevel()
    this.initMechineInfo()
  },
  watch: {
    dotimes(val) {
      if (val === 1) {
        this.nextPlay = true
      }
      if (val >= 2) {
        this.nextPlay = false
      }
    }
  },
  mounted() {
    this.$rightPlayer = new Audio(window.mp3.rightAnswerMp3)
    this.$wrongPlayer = new Audio(window.mp3.wrongAnswerMp3)
    this.initMachine()
    this.$store.dispatch('changLoadingStatus', false)

    document.addEventListener(
      'WeixinJSBridgeReady',
      e => {
        // play然后马上暂停，提前去加载音频
        this.$rightPlayer.play()
        this.stopRightPlayer()
        this.$wrongPlayer.play()
        this.stopWrongPlayer()
      },
      false
    )
  },
  computed: {
    // studentInfo() {
    //   return this.$store.getters.getUserInfo.base_info;
    // },
  },
  methods: {
    // 初始化难度等级
    initLevel() {
      const { week } = this.$route.params
      const level = Math.ceil(Math.random() * 5)
      if (level < 3) {
        this.level = 1
      } else if (level === 3) {
        this.level = 3
      } else {
        this.level = 5
      }
      // this.level = Math.ceil(+week / 10);

      // 初始化机器人信息
      // this.initMechineInfo();
    },

    handleScoreClose() {
      this.isScoreActive = false
      wx.miniProgram.navigateBack()
    },

    stopRightPlayer() {
      this.$rightPlayer.pause()
      this.$rightPlayer.currentTime = 0
    },

    stopWrongPlayer() {
      this.$wrongPlayer.pause()
      this.$wrongPlayer.currentTime = 0
    },

    // 显示作业要求model
    showRelusModel() {
      this.ruleModeShow = true
    },

    beforeClose() {},

    closeSuccessBack() {
      this.goBack()
    },

    loseDY(action, done) {
      if (action === 'confirm') {
        this.goBack()
        done()
      } else {
        this.dotimes = 0
        this.isWin = false
        this.whoisWIN = ''
        this.initLevel()
        this.initMachine()
        done()
      }
    },

    closeFailConfirm() {
      this.goBack()
    },

    checkWinScore() {
      if (this.winTimes === 2) {
        this.score = 25
      }
      if (this.winTimes === 1 && this.equalTimes === 1) {
        this.score = 20
      }
      if ((this.winTimes === 1 && this.loseTimes === 1) || this.equalTimes === 2) {
        this.score = 15
      }
      if (this.equalTimes === 1 && this.loseTimes === 1) {
        this.score = 10
      }
      if (this.loseTimes === 2) {
        this.score = 5
      }
      this.isScoreActive = true
    },

    // 关闭规则说明
    closeRelus() {
      this.ruleModeShow = false
    },
    // 初始化人机
    initMachine() {
      const that = this
      this.winStep = 0 // 用户提子数量
      this.machineStep = 0 // 机器人提子数量
      this.whoChess = 0 // 每次初始化都是黑棋先走
      if (this.mechine) {
        this.mechine.off()
      }
      this.mechine = new Island.ManMachine({
        $el: this.$refs.machine, // canvas对象
        sz: 9, // 棋盘大小
        width: 540, // canvas宽度
        level: that.level, // 机器人级别，1-5
        stones: 5, // 吃多少颗子算赢
        /**
         * 用户下子确认
         * x 坐标，y坐标
         */
        userChess({ x, y }) {
          that.isChess = true
          console.log({
            x,
            y
          })
        },
        // 机器思考
        etWant(type) {
          that.isChess = false
          if (type === 'wanting') {
            // 机器人在落子
            that.whoChess = 1
          } else {
            that.whoChess = 0
          }
        },
        /**
         * 吃子数量
         * bkilled 黑棋被吃子数量
         * wkilled 白棋被吃子数量
         */
        onKillStone(bkilled, wkilled) {
          that.winStep = wkilled
          that.machineStep = bkilled
        },
        /** 统一处理错误
         * @object code 0 机器在考虑，-1,pt在棋盘外, -2,pt处已有棋子,-3,打劫，要隔一步才能落子,-4,不允许自杀 -5 请先落子
         * @object message 提示信息
         */
        onError(data) {
          if (data) {
            if (data.code === -4 || data.code === -3 || data.code === -2 || data.code === -1 || data.code === -5) {
              that.msg(data.message)
            }
          }
        },
        /** 判断胜负触发函数
         * @param isWin true代表人赢，false代表机器赢
         * @param stones 吃子数量
         * @param level  机器人级别
         * @param sgf  生成sgf文件，可传给后盾保存一份
         */
        onSuccess(isWin, stones, level, sgf) {
          // 黑子赢（你）
          if (isWin && stones >= 5) {
            that.isWin = true
            that.whoisWIN = '黑胜'
            // 0是赢 1是负 2是平手
            that.submitHomeworkData(0, sgf)
            that.dotimes += 1
            that.successResultShow = true
            that.$rightPlayer.play()
            that.winTimes += 1
            setTimeout(() => {
              that.successResultShow = false
              if (that.dotimes >= 2) {
                that.checkWinScore()
              }
            }, 1000)
          }
          // 白子赢（机器）
          if (!isWin && stones >= 5) {
            that.isWin = true
            // this.failResultShow = true
            that.whoisWIN = '白胜'
            that.submitHomeworkData(1, sgf)
            that.dotimes += 1
            that.$wrongPlayer.play()
            that.loseTimes += 1
            that.failResultShow = true
            setTimeout(() => {
              that.failResultShow = false
              if (that.dotimes >= 2) {
                that.checkWinScore()
              }
            }, 1000)
          }
          // 平手
          if (isWin && isWin === 'flat') {
            that.isWin = true
            // that.$toast('打平了！')
            // this.equalResultShow = true
            that.whoisWIN = '平局'
            that.submitHomeworkData(2, sgf)
            that.dotimes += 1
            that.equalResultShow = true
            that.$rightPlayer.play()
            that.equalTimes += 1
            setTimeout(() => {
              that.equalResultShow = false
              if (that.dotimes >= 2) {
                that.checkWinScore()
              }
            }, 1000)
          }
        }
      })
    },
    // 人机需要确认 才会执行下一步
    manMechineClick() {
      this.mechine.submit()
    },
    // 再玩一局
    startOnce() {
      this.dotimes = 2
      this.isWin = false
      this.whoisWIN = ''
      this.initLevel()
      this.initMachine()
    },
    // 提示消息
    msg(str) {
      this.$toast(str)
    },
    // 初始化人机姓名头像
    initMechineInfo() {
      const mechineName = mechineNameArr.filter(({ level }) => +level === this.level)
      // 随机抽取一位
      this.mechineInfo = mechineName[Math.floor(Math.random() * mechineName.length)]
    },
    // 重新开始  -返回
    goBack() {
      wx.miniProgram.navigateBack()
    },
    // 提交数据打谱
    /**
     * sgf 对弈的详情
     */
    submitHomeworkData(play_res, sgf) {
      const { week, times } = this.$route.params
      const params = {
        week,
        times: times - 1,
        is_right: play_res, // 当题型是对弈时,有0:两局胜,1:两局负,2:一胜一负,3:两局平,4:一平一胜,5:一平一负(不限顺序) 六种情况
        content: sgf,
        robot_name: this.mechineInfo.name, // 机器人名字
        robot_avatar: this.mechineInfo.headerImg, // 机器人头像
        robot_k_value: this.mechineInfo.K_value * 1000, // 机器人K值
        student_steps: this.winStep,
        robot_steps: this.machineStep,
        is_x_type: 0
      }
      Api.saveMechineResult(params).then(res => {
        if (res.status === 0) {
          console.log(res)
        } else {
          this.$toast(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 重置样式 */
.wrong-modal.hide {
  .van-button {
    display: none !important;
  }
}
</style>

<style scoped lang="scss">
.man-machine {
  background: #fff4da;
  height: 100%;
  width: 100%;
  .header {
    height: halvePx(180);
    width: 100%;
    padding: 0 halvePx(40);
    display: flex;
    background: rgba(249, 234, 192, 1);
    align-items: center;
    justify-content: space-around;
    .user {
      display: flex;
      padding: halvePx(23) 0 0 0;
      width: 40%;
      height: 100%;
      .img {
        width: halvePx(100);
        height: halvePx(100);
        img {
          min-width: 100%;
          max-height: 100%;
          border-radius: 50%;
          border: halvePx(2) solid rgba(255, 255, 255, 1);
        }
        .witchOne {
          width: halvePx(100);
          height: halvePx(30);
          line-height: halvePx(30);
          text-align: center;
          background: rgba(111, 218, 121, 1);
          border-radius: halvePx(15);
          margin: halvePx(7) 0 0 0;
          font-size: halvePx(20);
          font-family: PingFang-SC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
      .user-item {
        flex: 1;
        margin-left: halvePx(15);
        margin-top: halvePx(10);
        display: flex;
        flex-direction: column;
        align-items: center;

        .username {
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: halvePx(28);
          height: halvePx(30);
          line-height: halvePx(30);
          font-family: PingFang-SC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
          margin-bottom: halvePx(10);
          div {
            max-width: 80%;
          }
          span {
            color: #ae9c73;
            font-size: halvePx(24);
            // flex: 1;
            text-align: right;
            margin: 0 0 0 halvePx(10);
          }
        }
        .status {
          width: halvePx(160);
          height: halvePx(40);
          line-height: halvePx(40);
          text-align: center;
          background: rgba(249, 216, 128, 1);
          border-radius: halvePx(20);
          font-size: halvePx(24);
          font-family: PingFang-SC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    .vs {
      width: halvePx(54);
      margin: auto halvePx(28);
      position: relative;
      div {
        font-size: halvePx(40);
        font-family: PingFang-SC-Regular;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        // margin-top: 50%;
      }
      .witchWin {
        width: halvePx(90);
        height: halvePx(30);
        line-height: halvePx(30);
        text-align: center;
        background: rgba(111, 218, 121, 1);
        border-radius: halvePx(15);
        font-size: halvePx(20);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        position: absolute;
        top: 0.5rem;
        left: -0.14rem;
      }
    }
  }

  .container {
    width: 100%;
    canvas {
      width: halvePx(650);
      height: halvePx(650);
      display: block;
      margin: auto;
    }
  }

  .confirm-button {
    width: halvePx(270);
    height: halvePx(100);
    line-height: halvePx(100);
    text-align: center;
    background: linear-gradient(180deg, rgba(144, 201, 251, 1), rgba(67, 172, 255, 1));
    border-radius: halvePx(50);
    font-size: halvePx(30);
    font-family: PingFang-SC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin: halvePx(50) auto 0;
    &.checkedGray {
      background: rgba(51, 51, 51, 0.2);
    }
  }
}
.longText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mes-right {
  margin-bottom: halvePx(35);
  margin-top: halvePx(28);
  height: halvePx(110);
  position: relative;
  img {
    width: halvePx(120);
    height: halvePx(120);
    position: absolute;
    right: halvePx(20);
  }
}
//
</style>
